import React, {useEffect} from "react";
import {useAuth} from "../context/AuthContext";
import {useRouter} from "../context/RouterContext";
import {useProfile} from "../context/ProfileContext";
import SimplePage from "./SimplePage";

const AdminRoute = ({children}: { children: React.ReactNode }) => {
    const {user, tcsSignIn} = useAuth()
    const {navigate} = useRouter();
    const {isAdmin} = useProfile();

    useEffect(() => {
        if (!user) {
            tcsSignIn()
        }
    }, [navigate, user, tcsSignIn])

    return (
        <>
            {
                (user && isAdmin()) ?
                    children :
                    <SimplePage>
                        <p>Restricted access</p>
                    </SimplePage>
            }
        </>
    )
}

export default AdminRoute